export function buildAdminDeps(shared = {}) {
  return {
    useToast: shared.useToast,
    useFarms: shared.useFarms,
    useSync: shared.useSync,
    useSysLists: shared.useSysLists,
    useGlobalCollection: shared.useGlobalCollection,
    normalizeAdminGlobalsConfig: shared.normalizeAdminGlobalsConfig,
    useDisplayedAppVersion: shared.useDisplayedAppVersion,
    readLocationSyncDebugSnapshot: shared.readLocationSyncDebugSnapshot,
    stripDeletedItems: shared.stripDeletedItems,
    isFarmArchived: shared.isFarmArchived,
    isDeletedItem: shared.isDeletedItem,
    normalizeServiceType: shared.normalizeServiceType,
    T: shared.T,
    Btn: shared.Btn,
    Field: shared.Field,
    Badge: shared.Badge,
    Input: shared.Input,
    Select: shared.Select,
    Textarea: shared.Textarea,
    Modal: shared.Modal,
    PwInput: shared.PwInput,
    StatCard: shared.StatCard,
    DB: shared.DB,
    apiCall: shared.apiCall,
    SYSTEM_LISTS_DEFAULTS: shared.SYSTEM_LISTS_DEFAULTS,
    COST_CENTERS: shared.COST_CENTERS,
    FARM_EMOJIS: shared.FARM_EMOJIS,
    FARM_COLORS: shared.FARM_COLORS,
    DEFAULT_VISIBLE_FARM_SPECIES: shared.DEFAULT_VISIBLE_FARM_SPECIES,
    fmtDate: shared.fmtDate,
    fmtDateTime: shared.fmtDateTime,
    createClientId: shared.createClientId,
    pruneDeletedAccounts: shared.pruneDeletedAccounts,
    persistAdminCredentialState: shared.persistAdminCredentialState,
    pickRuntimeMapsKey: shared.pickRuntimeMapsKey,
    SyncQueue: shared.SyncQueue,
    collectionLabel: shared.collectionLabel,
    formatCollectionLabelSafe: shared.formatCollectionLabelSafe,
    normalizeUiPreferences: shared.normalizeUiPreferences,
    buildConflictBusinessRows: shared.buildConflictBusinessRows,
    describeConflictRecord: shared.describeConflictRecord,
    formatConflictFieldLabel: shared.formatConflictFieldLabel,
    classifyConflictSeverity: shared.classifyConflictSeverity,
    normalizeConflictForUI: shared.normalizeConflictForUI,
    normalizeConflictListForUI: shared.normalizeConflictListForUI,
    getDeviceId: shared.getDeviceId,
    API_SECRET: shared.API_SECRET,
    BOOT_TELEMETRY_URL: shared.BOOT_TELEMETRY_URL,
    DEVICE_REGISTRY_URL: shared.DEVICE_REGISTRY_URL,
    ANIMAL_SPECIES: shared.ANIMAL_SPECIES,
    COLLAB_LEVELS: shared.COLLAB_LEVELS,
    DASHBOARD_CARDS: shared.DASHBOARD_CARDS,
    FarmCtx: shared.FarmCtx,
    FarmDashboard: shared.FarmDashboard,
    farmDashboardDeps: shared.farmDashboardDeps,
    FarmEmoji: shared.FarmEmoji,
    InspectionsModule: shared.InspectionsModule,
    MODULES: shared.MODULES,
    OccurrencesModule: shared.OccurrencesModule,
    PERMISSION_ACTIONS: shared.PERMISSION_ACTIONS,
    PURCHASE_ITEM_STATUS_META: shared.PURCHASE_ITEM_STATUS_META,
    ProvidersModule: shared.ProvidersModule,
    PurchasesHubModule: shared.PurchasesHubModule,
    SHORTCUT_MODULE_CHOICES: shared.SHORTCUT_MODULE_CHOICES,
    SVC_STATUS_FLOW: shared.SVC_STATUS_FLOW,
    ServicePhotoStatusIcon: shared.ServicePhotoStatusIcon,
    ShortcutMonoIcon: shared.ShortcutMonoIcon,
    StockModule: shared.StockModule,
    SuppliersModule: shared.SuppliersModule,
    SyncStatusBar: shared.SyncStatusBar,
    SystemListsManager: shared.SystemListsManager,
    Toast: shared.Toast,
    UI_FONT_SCALE_OPTIONS: shared.UI_FONT_SCALE_OPTIONS,
    USER_DELETION_LOG_KEY: shared.USER_DELETION_LOG_KEY,
    VISIBLE_MODULES: shared.VISIBLE_MODULES,
    buildAllCostCenterPermissions: shared.buildAllCostCenterPermissions,
    buildAllModulePermissions: shared.buildAllModulePermissions,
    buildPersonDisplayName: shared.buildPersonDisplayName,
    cursorKey: shared.cursorKey,
    dedupeEmployeeLinkOptions: shared.dedupeEmployeeLinkOptions,
    deriveAllowedModules: shared.deriveAllowedModules,
    emptyCostCenterPermissionSet: shared.emptyCostCenterPermissionSet,
    emptyPermissionSet: shared.emptyPermissionSet,
    ensureDefaultAdminAccount: shared.ensureDefaultAdminAccount,
    flattenModuleCardSections: shared.flattenModuleCardSections,
    getModuleCardLibrary: shared.getModuleCardLibrary,
    getModuleCardSections: shared.getModuleCardSections,
    getPriorityConfig: shared.getPriorityConfig,
    getPurchaseItemStatus: shared.getPurchaseItemStatus,
    getShortcutChoiceMeta: shared.getShortcutChoiceMeta,
    isCompactViewport: shared.isCompactViewport,
    makeCreateMeta: shared.makeCreateMeta,
    makeUpdateMeta: shared.makeUpdateMeta,
    normalizeAuthAccount: shared.normalizeAuthAccount,
    normalizeCostCenterPermissions: shared.normalizeCostCenterPermissions,
    normalizeFarmRecord: shared.normalizeFarmRecord,
    normalizeFarmSpeciesList: shared.normalizeFarmSpeciesList,
    normalizeFarmsCollection: shared.normalizeFarmsCollection,
    normalizeModulePermissions: shared.normalizeModulePermissions,
    opsKey: shared.opsKey,
    pendingKey: shared.pendingKey,
    pruneDeletedEmployees: shared.pruneDeletedEmployees,
    roleColor: shared.roleColor,
    setLiveCollectionCache: shared.setLiveCollectionCache,
    shadowKey: shared.shadowKey,
    splitPersonNameParts: shared.splitPersonNameParts,
    verKey: shared.verKey,
    writeAdminPasswordOverride: shared.writeAdminPasswordOverride,
    pushCollection: shared.pushCollection,
    pullGlobal: shared.pullGlobal,
    pushGlobal: shared.pushGlobal,
    ServicesModule: shared.ServicesModule,
  };
}

